import { Shapes, ListOrdered, Puzzle, History, Network } from "lucide-react";
import { SortGame } from "../SortGame";
import { MatchGame } from "./MatchGame";
import { SequenceGame } from "./SequenceGame";

export const GAME_INFO = {
  match: { name: "Match it", icon: Shapes, tip: "Pair words with pictures and meanings" },
  order: { name: "Order it", icon: ListOrdered, tip: "Put the steps in order" },
  sort: { name: "Sort it", icon: Puzzle, tip: "Drag ideas into groups" },
  timeline: { name: "Timeline", icon: History, tip: "Order events against the clock" },
  concept: { name: "Concept map", icon: Network, tip: "Connect ideas to the big idea" },
};
const young = (g) => g === "K" || (/^\d+$/.test(g || "") && Number(g) <= 5);
export const gamesFor = (grade) => (young(grade) ? ["match", "order", "sort"] : ["timeline", "concept", "sort"]);

export const GamePicker = ({ req, lesson, onResult, kind: chosen, setKind }) => {
  const list = gamesFor(req.grade);
  const kind = list.includes(chosen) ? chosen : list[0];
  const props = { req, lesson, onResult };
  return (
    <div data-testid="game-picker">
      <div className="flex flex-wrap gap-2 mb-5">
        {list.map((k) => { const { name, icon: Icon, tip } = GAME_INFO[k]; return (
          <button key={k} type="button" onClick={() => setKind(k)} aria-pressed={kind === k} title={tip} data-testid={`game-pick-${k}`}
            className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-2xl border text-sm transition-colors ${kind === k ? "bg-[#2C4A3E] text-white border-[#2C4A3E]" : "bg-white text-[#2C4A3E] border-[#E6DEC3] hover:bg-[#F1EADB]"}`}>
            <Icon className="w-4 h-4" />{name}</button>); })}
      </div>
      {kind === "match" && <MatchGame key="match" {...props} />}
      {(kind === "order" || kind === "timeline") && <SequenceGame key={kind} kind={kind} {...props} />}
      {(kind === "sort" || kind === "concept") && <SortGame key={kind} kind={kind} {...props} />}
    </div>
  );
};
